import React from 'react'

const Calendar = () => {
    
    const getFirstWeekDays = () => {
        const today = new Date();
        const firstDayOfWeek = new Date(today);
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] ;

        const weekdays = [];

        for (let i = 1; i <= 5; i++) {
            const date = new Date(firstDayOfWeek);
            date.setDate(firstDayOfWeek.getDate() - firstDayOfWeek.getDay() + i);

            weekdays.push({ day: days[date.getDay()], date: date.getDate() });
        }

        return weekdays;
        };
        const weekdays = getFirstWeekDays();

        const isCurrentDay = (i) =>{
            const currentDay = new Date().getDay();
            return currentDay === i + 1 ? true : false;
        }

        const calendarStyle = {
            color: '#fff',
            background: 'rgb(43, 52, 71)'
        }

  return (
    <>
    <div className="calendar">
        <h3>Date</h3>
        <ul>
            {weekdays.map((day, index) => (
                <li key={index} style={isCurrentDay(index) ? calendarStyle : {}} >
                    <span>{day.date}</span>
                    <span>{day.day}</span>
                </li>
            ))}
        </ul>
    </div>
    </>
  )
}

export default Calendar